import {ACTION_CODE} from './_actionCode';
import {VehicleTypeService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'UPDATE_VEHICLETYPE';

export async function updateVehicleType(
    userData: Record<string, any>,
    vehicleTypeId: number,
    payloadUpdate: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - updateVehicleTypeById - Start');

        const updateVehicleTypeByIdResult =
            await VehicleTypeService.updateVehicleType(userData, vehicleTypeId, payloadUpdate);

        LoggerService.logInfo('Action - updateVehicleTypeById - End - Success');

        return ResultModel.newSuccessResult(updateVehicleTypeByIdResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateVehicleTypeById - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur de mise à jour d\'une banque',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
